module.exports = __webpack_public_path__ + "img/stamp.1222476b.png";